import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

const DIALOG_CONTENT = {
  agreement: {
    title: 'Confirm terms agreed',
    description: 'Record the actual agreed price and key terms before moving into legal due diligence.',
    amountLabel: 'Agreed price',
    notesLabel: 'Agreed terms',
    saveLabel: 'Confirm Agreement',
    fieldPrefix: 'agreement',
    placeholder: 'Record agreed terms...',
  },
  initial_offer: {
    title: 'Confirm initial offer submitted',
    description: 'Record the actual amount sent to the agent or vendor.',
    amountLabel: 'Submitted offer amount',
    notesLabel: 'Offer notes',
    saveLabel: 'Confirm Offer Submitted',
    fieldPrefix: 'initial-offer',
    placeholder: 'Record offer context...',
  },
  counter: {
    title: 'Log vendor counter',
    description: 'Record the vendor\'s actual counteroffer before updating negotiation guidance.',
    amountLabel: 'Counter amount',
    notesLabel: 'Counter notes',
    saveLabel: 'Save Counter',
    fieldPrefix: 'vendor-counter',
    placeholder: 'Add agent or vendor context...',
  },
}

export function CounterOfferDialog({
  open,
  mode = 'counter',
  amount,
  notes,
  error,
  isSaving,
  onOpenChange,
  onAmountChange,
  onNotesChange,
  onSave,
}) {
  const content = DIALOG_CONTENT[mode] || DIALOG_CONTENT.counter

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{content.title}</DialogTitle>
          <DialogDescription>{content.description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor={`${content.fieldPrefix}-amount`}>{content.amountLabel}</Label>
            <div className="relative">
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-y-0 left-3 flex items-center font-semibold text-muted-foreground"
              >
                £
              </span>
              <Input
                id={`${content.fieldPrefix}-amount`}
                value={amount}
                inputMode="decimal"
                autoFocus
                aria-invalid={Boolean(error)}
                aria-describedby={error ? `${content.fieldPrefix}-error` : undefined}
                className="pl-7"
                onChange={(event) => onAmountChange?.(event.target.value)}
              />
            </div>
            {error ? (
              <p id={`${content.fieldPrefix}-error`} className="text-sm font-medium text-destructive">
                {error}
              </p>
            ) : null}
          </div>

          <div className="space-y-2">
            <Label htmlFor={`${content.fieldPrefix}-notes`}>{content.notesLabel}</Label>
            <Textarea
              id={`${content.fieldPrefix}-notes`}
              value={notes}
              rows={3}
              placeholder={content.placeholder}
              className="resize-none"
              onChange={(event) => onNotesChange?.(event.target.value)}
            />
          </div>
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange?.(false)}>
            Cancel
          </Button>
          <Button type="button" disabled={isSaving} onClick={onSave}>
            {isSaving ? 'Saving...' : content.saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
